/* NOTE: Resolving 'eslint-disable prefer-arrow-functions'
// will require architecture and refactoring of the entire WW engine
*/
import { CoreCustomCardType } from '@workflow/class/workflow.type';
import { CoreCustomBase } from '@workflow/dynamic-render/card/shared/core-custom-card.decorator';

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type CustomCardType = CoreCustomCardType | 'cu-document-card-fields';

// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
export function CustomCard(controlType: CustomCardType): (target) => void {
  return (target) => CoreCustomBase<CustomCardType>(controlType, target);
}
